"use client"

import * as React from "react"
import { createContext, useContext, useState } from "react"

interface User {
  id?: string
  email: string
  firstName?: string
  lastName?: string
  displayName?: string
  imageUrl?: string
}

interface AuthContextType {
  user: User | null
  workspaceId: string | null
  isAuthenticated: boolean
  logout: () => Promise<void>
  switchWorkspace: (workspaceId: string) => void
}

const MOCK_USER: User = {
  id: "dev-user-id",
  email: "admin@recipientfirewall.com",
  firstName: "Admin",
  lastName: "User",
  displayName: "Admin User",
}

const AuthContext = createContext<AuthContextType | null>(null)

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [user] = useState<User | null>(MOCK_USER)
  const [workspaceId, setWorkspaceId] = useState<string | null>("default-workspace")

  const logout = async () => {
    window.location.href = "/recipients"
  }

  const switchWorkspace = (newWorkspaceId: string) => {
    setWorkspaceId(newWorkspaceId)
    window.location.reload()
  }

  return (
    <AuthContext.Provider
      value={{
        user,
        workspaceId,
        isAuthenticated: true,
        logout,
        switchWorkspace,
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth() {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider")
  }
  return context
}
